export const codeEmail = (email: string): string =>
  email
    .split('')
    .map((symbol, index, array) => {
      if (symbol === '@' || symbol === '.') {
        return symbol;
      }
      if (index > 1 && index < array.length - 2) {
        return '*';
      }

      return symbol;
    })
    .join('');
